import { render, staticRenderFns } from "./MenschPage.vue?vue&type=template&id=50be4108&scoped=true&"
import script from "./MenschPage.vue?vue&type=script&lang=js&"
export * from "./MenschPage.vue?vue&type=script&lang=js&"
import style0 from "./MenschPage.vue?vue&type=style&index=0&id=50be4108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be4108",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
